<template>
  <div class="examResult">
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :sm="12" :md="5" :lg="5">
          <el-date-picker
            style="width:100%"
            v-model="searchForm.date"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-col>
        <el-col :sm="12" :md="5" :lg="5">
          <el-cascader
            clearable
            style="width:100%"
            v-model="searchForm.courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
          ></el-cascader>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:20px;">
        <el-tab-pane label="用户管理" name="first">
          <el-table
            ref="multipleTable"
            :data="page.rows"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            tooltip-effect="dark"
            style="width: 100%;"
            border
          >
            <el-table-column show-overflow-tooltip prop="name" label="排名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="resourceDescription" label="姓名"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="手机号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="classInfo.campusName" label="所属校区"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="班级"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="课程"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="考卷"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="考试得分"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="做题时长"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next, jumper,  total, sizes"
            style="margin-top: 20px;text-align: left;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="题目解析" name="second">
          <el-table
            ref="multipleTable"
            :data="page.rows"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            tooltip-effect="dark"
            style="width: 100%;"
            border
          >
            <el-table-column show-overflow-tooltip prop="name" label="排序"></el-table-column>
            <el-table-column show-overflow-tooltip prop="resourceDescription" label="类型"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="章节考点"></el-table-column>
            <el-table-column show-overflow-tooltip prop="resourceDescription" label="题干"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="答案"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="做题人数"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" label="正确率"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next, jumper,  total, sizes"
            style="margin-top: 20px;text-align: left;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      classInfoList: [],
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      searchForm: {},
      formLabelWidth: "80px",
      loading: false
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    getAgentRoleInfo(id) {
      this.api.agentRoleInfo
        .getAgentRoleInfo({
          id: id
        })
        .then(result => {
          this.editForm = result.data;
          console.log("this.editForm", this.editForm);
          this.editFormVisible = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                }
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.agentRoleInfo
        .pageList(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAgentRoleInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.agentId = this.loginData.agentId;
          this.api.agentRoleInfo
            .addAgentRoleInfo(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentRoleInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editForm.agentId = this.loginData.agentId;
          this.api.agentRoleInfo
            .updateAgentRoleInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentRoleInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.agentRoleInfo
            .deleteAgentRoleInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                const totalPage = Math.ceil(
                  (this.page.total - 1) / this.page.pageSize
                );
                const pagenum =
                  this.page.pageNumber > totalPage
                    ? totalPage
                    : this.page.pageNumber;
                this.page.pageNumber = pagenum < 1 ? 1 : pagenum;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    getClassInfoList(id) {
      this.api.classInfo
        .getClassInfoList({ campusId: id })
        .then(result => {
          if (result.success) {
            this.classInfoList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleClick(tab, event) {
      this.getSubjectTreeList();
      this.getClassInfoList();
    },
    getMobiles() {
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names
        .split("")
        .reverse()
        .join("")
        .split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
    getMobiless() {
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names
        .split("")
        .reverse()
        .join("")
        .split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach(element => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach(item => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    }
  },
  watch: {},
  mounted() {}
};
</script>
<style scoped>
.examResult-text {
  line-height: 40px;
  font-size: 14px;
}
.examResult-text2 {
  line-height: 40px;
  font-size: 14px;
  color: #4d94ff;
}
.examResult-addStudent {
  margin-top: 20px;
  text-align: right;
}
</style>
<style lang="less" rel="stylesheet/less">
.examResult {
  .addDialog {
    .el-dialog__body {
      padding-top: 10px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/examPaperResult.vue